import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IAuthorizationData from "../../../core/src/server/data/IAuthorizationData";

import GameModel from "../../../core/src/model/GameModel";

export default class AuthorisationDataParser
    implements IBaseDataParser<IAuthorizationData> {
    check(data: any): boolean {
        return data?.data?.userId;
    }

    parse(data): IAuthorizationData[] {

        const result:IAuthorizationData = {
            playerConfig: {
                userId: data.data.userId ,
                isDemoPlayer:true, // TODO
                currency: "", //TODO MAYBE THERE IS SOME MAPPING
            },
        };

        return [result];
    }


}
